import * as types from '../constants/instrumentListConstants';
import * as acttypes from '../constants/activityConstants';
import * as instrumentListActions from './../actions/instrumentListActions.js';
import config from './../config.js';
import appConstants from './../appConstants.js'
import * as authTypes from '../redux/modules/auth'
import moment from 'moment';
const initialState = {
  loading: false,
  AccChange:false,
  loaded: false,
  check:1234,
  socketData:null,
  cmdt:"",
  cmdtArr:[],
  apiFlag:false,
  socketDataStatic: [],
  socketNeoData:[],
  trdPanelData:[],
  webSocketFlag:false,
  accBalMargBean:{
    totfunds:0,
   totReval:0,
   excess:0,
   totmargin:0,
   margPerc:0,
   margPercLable:0,
   lossLimit:0,
   TQFlag:false,
   UQFlag:false,
   OQFlag:false,
   FOQFlag:false,
   detonlBeanMap:null,
   detFundsBeanMap:null,
   detOrderBeanMap:null,
   detFOBeanMap:null,
   detTransitBeanMap:null,
   detUnallocBeanMap:null,
   detPhysicalBeanMap:null
  },
  status: "1",
  socketDataRandomNo:0,
  limitOrdBookProxi:[],
  proxiRandomNo:0,
  cmdtyArr:[],
  DCO:[],
  TCO:[],
  opentradeBook: {
	  opentradesData:null,
	  randomNo: 0
	},
	openTradeLoaderFlag:true,
	openTrdRandomNoDB:0,
  stkWiseMarkup:null,
  stkWiseMarkupRandomNo:0,
  socketAllRate:null,
  loadAllRate:false,
  custInstStkData:[],
  dropdown:[],
  wsStatus: ''
};

const updateAccbalBeanMrgPerc =(msg,accBal,instList,neoList) =>{
   //[{"STK":"EUR","P":6.0,"IID":1},{"STK":"GLD","P":8.0,"IID":12},"PLD":4.0,"SLV":5.0}]
   const defAC=JSON.parse(localStorage.getItem('DFA')).C;
   const instItem = Object.assign([], instList);
   const neoItem = Object.assign([], neoList);

 //   try{
 //   if(msg.AC===defAC){
 //     msg.CM.map((item,index)=>{
 //       if((item.IID)!=="" && (item.IID)!==null){
 //         let askRate;
 //         let bidRate;
 //         let index1;
 //           for ( let index= 0; index < instItem.length; index++) {
 //               if ((instItem[index].I) === (item.IID)) {
 //                 index1 = index;
 //                 break;
 //           }
 //         }
 //         askRate=instItem[index1].MA;
 //         bidRate=instItem[index1].MB;
 //         if(accBal.detonlBeanMap.get((item.IID))){
 //             accBal.detonlBeanMap.get((item.IID)).MP=item.P;
 //             accBal.detonlBeanMap.get((item.IID)).MA=calculateValue(accBal.detonlBeanMap.get((item.IID)),accBal.detonlBeanMap.get((item.IID)).MP,askRate,bidRate,accBal.FD,"Q");
 //             accBal.detonlBeanMap.get((item.IID)).V=calculateValue(accBal.detonlBeanMap.get((item.IID)),100,askRate,bidRate,accBal.FD,"Q");
 //           }
 //       }
 //       else{
 //         let askRate;
 //         let bidRate;
 //         let index1;
 //           for ( let index= 0; index < length; index++) {
 //               if ((neoItem[index].stk_type) === (item.IID)) {
 //                 index1 = index;
 //                 break;
 //           }
 //         }
 //         askRate=neoItem[index1].ask_price;
 //         bidRate=neoItem[index1].bid_price;
 //         if(accBal.detneoBeanMap.get(item.STK)){
 //             accBal.detneoBeanMap.get(item.STK).MP=item.P;
 //             accBal.detneoBeanMap.get(item.STK).MA=calculateValue(accBal.detneoBeanMap.get(item.STK),accBal.detneoBeanMap.get(item.STK).MP,askRate,bidRate,accBal.FD,"Q");
 //             accBal.detneoBeanMap.get(item.STK).V=calculateValue(accBal.detneoBeanMap.get(item.STK),100,askRate,bidRate,accBal.FD,"Q");
 //           }
 //       }
 //     });
 //     let mfnop;
 //     if(parseInt(msg.MFNOP)===1){
 //       mfnop=true;
 //     }
 //     else {
 //       mfnop=false;
 //     }
 //     return{
 //         defacccode:accBal.defacccode,
 //         mrgPerc:parseFloat(msg.MP),
 //         lossLimit:parseFloat(msg.LL),
 //         nopLimit:parseFloat(msg.NOPL),
 //         dealValLimit:parseFloat(msg.DL),
 //         haltMrgPerc:parseFloat(msg.HM),
 //         FD:accBal.FD,
 //         marginFreeNOP:mfnop,
 //         detFundsBeanMap:accBal.detFundsBeanMap,
 //         detonlBeanMap:accBal.detonlBeanMap,
 //         detneoBeanMap:accBal.detneoBeanMap,
 //         TQFlag:accBal.TQFlag,
 //         UQFlag:accBal.UQFlag,
 //         OQFlag:accBal.OQFlag,
 //   }
 //   }
 //   else {
 //     return accBal;
 //   }
 // }catch(e){console.log(e);}
 }

const getAccountBalMargin = (rateData,accBalMargData) =>{
    var obj={};
    try{
	   obj.totfunds= accBalMargData.F;
	  obj.totReval= accBalMargData.R;
	  obj.excess= accBalMargData.FE;
	  obj.totmargin= accBalMargData.M;
	  obj.margPerc= accBalMargData.MP;
    obj.noOrdtotfunds=accBalMargData.F;
    obj.noOrdtotReval=accBalMargData.R;
    obj.noOrdtotmargin=accBalMargData.M;
    obj.noOrdmargPerc=accBalMargData.MP;
    obj.noOrdexcess=accBalMargData.FE;
    obj.margPercLable= accBalMargData.P;
    obj.lossLimit=accBalMargData.L;
    // obj.TQFlag=accBalMargData.TR.length>0?true:false;
    // obj.UQFlag=accBalMargData.UA.length>0?true:false;
    obj.TQFlag=false;
    obj.UQFlag=false;
    obj.OQFlag=false;
    obj.FOQFlag=false;
	   var SP = new Map();
     var SF =new Map();
     var ORD =new Map();
     var FO =new Map();
     var UA =new Map();
     var TR =new Map();
     var DL =new Map();
	     accBalMargData.SP.map((item,index) => {
         var Obj={};
         Obj.C=item.suf_code;
         Obj.Q=item.fc_amt;
         Obj.D=item.suf_desc;
         var obj={};
         obj.RA=item.amt;//need to check api call
         obj.tick=item.rate;//need to check api call
         obj.RO=item.amt;
         Obj.STK_VAL=obj;
	       SP.set(item.suf_code,Obj);
	     });
       accBalMargData.ORD.map((item,index) => {
         var Obj={};
         Obj.D=item.suf_desc;
         Obj.OQ=item.fc_amt;
         var obj={};
         obj.RO=item.amt;
         obj.tick=item.rate;
         Obj.STK_VAL=obj;
         ORD.set(item.suf_code,Obj);
       });
       accBalMargData.FO.map((item,index) => {
         var Obj={};
         Obj.D=item.suf_desc;
         Obj.FQ=item.fc_amt;
         var obj={};
         obj.FO=item.amt;
         obj.tick=item.rate;
         Obj.STK_VAL=obj;
         FO.set(item.suf_code,Obj);
       });
       accBalMargData.UA.map((item,index) => {
         var Obj={};
         Obj.D=item.suf_desc;
         Obj.UQ=item.fc_amt;
         var obj={};
         obj.RU=item.amt;
         obj.tick=item.rate;
         Obj.STK_VAL=obj;
         UA.set(item.suf_code,Obj);
       });
       accBalMargData.TR.map((item,index) => {
         var Obj={};
         Obj.D=item.suf_desc;
         Obj.TQ=item.fc_amt;
         var obj={};
         obj.RT=item.amt;
         obj.tick=item.rate;
         Obj.STK_VAL=obj;
         TR.set(item.suf_code,Obj);
       });
       accBalMargData.FB.map((item,index)=>{
         var Obj={};
         Obj.C=item.suf_code;
         Obj.Q=item.fc_amt;
	       SF.set(item.suf_code,Obj);
       })
      accBalMargData.DL.map((item,index)=>{
        var Obj={};
        Obj.C=item.suf_code;
        Obj.D=item.suf_desc;
        Obj.DQ=item.fc_amt;
        Obj.format=item.suf_format;
        let obj={};
        obj.DO=item.amt;
        obj.tick=item.rate;
        Obj.STK_VAL=obj;
        DL.set(item.suf_code,Obj);
      });
   obj.detonlBeanMap=SP;
   obj.detFundsBeanMap=SF;
   obj.detOrderBeanMap=ORD;
   obj.detFOBeanMap=FO;
   obj.detUnallocBeanMap=UA;
   obj.detTransitBeanMap=TR;
   obj.detPhysicalBeanMap=DL;
 }
   catch(e){
     console.log(e);
   }
   return obj;
	}

  const noMrgGetAccountBalMargin = (rateData,accBalMargData) =>{
    var obj = {};
    try{
      obj.totalFundsNoMarginOrd = accBalMargData.TF[0].totFunds;
      obj.netFunds = accBalMargData.TF[0].netFunds;
      obj.buyOrdFunds = accBalMargData.TF[0].ordFunds;
      obj.noMrgOrdLossLimt=accBalMargData.TF[0].LossLmt;
      obj.noMrgRevaluation = accBalMargData.TF[0].totReval
      obj.noMrgNetEquity = accBalMargData.TF[0].netEquity

      var STK = new Map();
      //var IF = new Map();

      accBalMargData.STK.map((item, index) => {
        var Obj={};
        Obj.C=item.suf_code;
        Obj.D=item.suf_desc;
        Obj.Q=item.amt;
        Obj.OQ=item.ord_amt;
        Obj.NP=item.net_amt;
        STK.set(item.suf_code, Obj);
      });
      obj.detonlBeanMap=STK;

     } catch(e){console.log(e);}
     return obj;
	}

  const getInitialSocketData = (instrumentList) => {
    try{
      var tempInstList=new Map();
       instrumentList.map((item,index) => {
        var dec;
        if((item.TR).toString().split(".")[1]){
          dec = (item.TR).toString().split(".")[1].length
        }
        else{
          dec = 0;
        }
        var BMdec;
        if((item.BRF).toString().split(".")[1]){
          BMdec = (item.BRF).toString().split(".")[1].length
        }
        else{
          BMdec = 0;
        }
        var mf = JSON.parse(item.PTN).mf;
        var rf = JSON.parse(item.PTN).rf;
        item.ask =item.MA.toFixed(dec);
        item.bid=item.MB.toFixed(dec);
        item.cmdty=item.ID;
        item.dec=dec;
        item.BMdec= BMdec;
        item.RT=new Date().valueOf();
        var diff=Math.abs(Math.round(((item.MB.toFixed(dec)-item.MA.toFixed(dec)))*mf)).toFixed(rf);
        item.diff=diff;
        tempInstList.set(item.I,item);
        //localStorage.setItem(item.I, JSON.stringify(item));
        });
    }catch(e){
      console.log(e);
    }
  return tempInstList;
};

const setDCO =(instrumentList) =>{
  try{
  var dcoArr=[];
   var DCO=new Map(JSON.parse(localStorage.getItem("DCO")));
  instrumentList.map((item,index) => {
      var obj =DCO.get(item.I);
      if(obj !== undefined){
        obj.cmdtDesc=item.ID;
        dcoArr.push(obj);
      }
  });
  //localStorage.removeItem("DCO");
}catch(e){console.log(e);}
  return dcoArr;
}

const setTCO =(instrumentList) =>{
  try{
  var tcoArr=[];
   var TCO=new Map(JSON.parse(localStorage.getItem("TCO")));
  instrumentList.map((item,index) => {
      var obj =TCO.get(item.I);
      if(obj !== undefined){
        obj.cmdtDesc=item.ID;
        tcoArr.push(obj);
      }
  });
//  localStorage.removeItem("TCO");
}catch(e){console.log(e);}
  return tcoArr;
}

const getInitialStaticSocketData = (instrumentList) => {
  return instrumentList.map((item,index) => {
    var dec;
    if((item.TR).toString().split(".")[1]){
      dec = (item.TR).toString().split(".")[1].length
    }
    else{
      dec = 0;
    }
    var BMdec;
    if((item.BRF).toString().split(".")[1]){
      BMdec = (item.BRF).toString().split(".")[1].length
    }
    else{
      BMdec = 0;
    }
    var mf = JSON.parse(item.PTN).mf;
    var rf = JSON.parse(item.PTN).rf;
    item.ask =item.MA.toFixed(dec);
    item.bid=item.MB.toFixed(dec);
    item.cmdty=item.ID;
    item.dec=dec;
    item.BMdec= BMdec;
    var diff=Math.abs(Math.round(((item.MB.toFixed(dec)-item.MA.toFixed(dec)))*mf)).toFixed(rf);
    item.diff=diff;
    return {
      ...item,
      ask:   item.MA.toFixed(dec),
      bid:   item.MB.toFixed(dec),
      cmdty: item.ID,
      dec:  dec,
      BMdec:  BMdec,
      diff: diff
    };
  });
};

const getInstData= (instrumentList) => {
  var tempInstData=new Map();
  instrumentList.map((item,index) => {
    var dec;
    if((item.trd_rate_fmt).toString().split(".")[1]){
      dec = (item.trd_rate_fmt).toString().split(".")[1].length
    }
    else{
      dec = 0;
    }
    var BMdec;
    if((item.BRF).toString().split(".")[1]){
      BMdec = (item.BRF).toString().split(".")[1].length
    }
    else{
      BMdec = 0;
    }
    var mf = JSON.parse(item.PTN).mf;
    var rf = JSON.parse(item.PTN).rf;
    item.ask =item.ask_price.toFixed(dec);
    item.bid=item.bid_price.toFixed(dec);
    item.cmdty=item.inst_id;
    item.dec=dec;
    item.BMdec= BMdec;
    var diff=Math.abs(Math.round(((item.bid_price.toFixed(dec)-item.ask_price.toFixed(dec)))*mf)).toFixed(rf);
    item.diff=diff;

    item.B=item.BC;
    item.BRF=item.BRF;
    item.C=item.isCrossDoc;
    item.CB=item.comm_bitcode;
    item.CC=item.con_code;
    item.D=item.amt_dorm;
    item.D1=item.stk_desc;
    item.D2=item.cntr_desc;
    item.DF=item.DF;
    item.EA=0;
    item.EB=0;
    item.EM=0;
    item.H=item.high;
    item.I=item.inst_id;
    item.ID=item.inst_desc;
    item.L=item.low;
    item.MNHQ=item.MNHQ;
    item.MXHQ=item.MXHQ;
    item.P=item.P;
    item.PTN=item.PTN;
    item.R=item.qty_roundoff;
    item.T1=item.stk_type;
    item.T2=item.cntr_type;
    item.TR=item.trd_rate_fmt;
    item.EBid=item.MCO_B;
    item.EAsk=item.MCO_A;
    item.ask=   item.ask_price.toFixed(dec);
    item.bid=   item.bid_price.toFixed(dec);
    tempInstData.set(item.inst_id,item);
    localStorage.setItem(item.inst_id, JSON.stringify(item));
  });
  return tempInstData;
};

const getInitialTradeData = (trdDataList) => {
  return trdDataList.map((item,index) => {
    return {
      ...item
    };
  });
};

const getCmdtyArry = (message) => {
  const msg = JSON.parse(message.data).data;
  var temparray = [];
  for(var index=0;index<msg.length;index++)
  {
    const msgIndx=JSON.parse(msg[index]);
    temparray.push(msgIndx.I);
  }
  return temparray;
}

const getUpdatedSocketData = (socketData, message) => {

    const msg = JSON.parse(message.data).data;
    const rateObj = msg.rate;
    const marginObj = msg.mrgn;

    for(var index=0;index<rateObj.length;index++)
    {
      const msgIndx=rateObj[index];
      const cmdty = msgIndx.I;
      if(socketData.length === 0){
        continue;
      }
      const item=socketData.get(cmdty);
      if(item === undefined){
          continue;
      }
      item.askTiers=msgIndx.askTiers;
      item.bidTiers=msgIndx.bidTiers;
      item.Tr_A=[];
      item.Tr_B=[];

      if(msgIndx.T_A)
      {
        item.Tr_A=msgIndx.T_A;
      }
      if(msgIndx.T_B)
      {
        item.Tr_B=msgIndx.T_B;
      }
      let change = null;
      if (socketData.get(cmdty).bid && socketData.get(cmdty).bid < msgIndx.MB) {
        change = 'increment';
      } else if (socketData.get(cmdty).bid && socketData.get(cmdty).bid > msgIndx.MB) {
        change = 'decrement';
      }
      if (change !== null) {
        socketData.get(cmdty).variationInBid = change;
      }
      item.bid = msgIndx.MB.toFixed(item.dec);
      change = null;
      if (socketData.get(cmdty).ask && socketData.get(cmdty).ask < msgIndx.MA) {
        change = 'increment';
      } else if (socketData.get(cmdty).ask && socketData.get(cmdty).ask > msgIndx.MA) {
        change = 'decrement';
      }
      if (change !== null) {
        socketData.get(cmdty).variationInAsk = change;
      }
      item.ask = msgIndx.MA.toFixed(item.dec);
      try{
          item.H = msgIndx.H.toFixed(item.dec);
          item.L = msgIndx.L.toFixed(item.dec);
      }catch(e){

      }
      item.D = msgIndx.D;
      item.dec = item.dec;
      item.BMdec = item.BMdec;
      item.ch=item.ask-item.bid;
      item.RT =msgIndx.RT;
      item.QTA=msgIndx.QTA;
      item.QTB=msgIndx.QTB;
      item.BI=msgIndx.BI;
      item.STATUS=msgIndx.S;
      item.LA = msgIndx.LA
      item.LB = msgIndx.LB
      item.SA = msgIndx.SA
      item.SB = msgIndx.SB
      
      socketData.set(msgIndx.I,item);

    }
    return socketData;
  }

const getUpdateAccBalMrg = (state, message) =>{
    /*const msg = JSON.parse(message.data).data;
    for(var index=0;index<msg.length;index++)
    {
          //console.log(msg[index]);
          const marginData=msg[index].mrgn;
          const AccBal=JSON.parse(marginData.CURR_BAL);
          //console.log("AccBal "+JSON.stringify(marginData));
          var F= marginData.CURR_WITH_ORD_FUNDS;
      	  var R= marginData.CURR_WITH_ORD_REVAL;
      	  var FE= marginData.CURR_WITH_ORD_EXC_SHORT;
      	  var M= marginData.CURR_WITH_ORD_MAR;
          var P=AccBal.MP;
      	  var MP= marginData.CURR_WITH_ORD_MARG_AT_PERC;
      	  var SP = new Map();
          var SF =new Map();
      	    AccBal.STKA.map((item,index) => {
      	      SP.set(item.C,item);
      	    });
            AccBal.FA.map((item,index) => {
      	      SF.set(item.C,item);
      	    });
    }*/

    if(message!=undefined){
      var F= message.CURR_WITH_ORD_FUNDS;
      var R= message.CURR_WITH_ORD_REVAL;
      var FE= message.CURR_WITH_ORD_EXC_SHORT;
      var M= message.CURR_WITH_ORD_MARG_AT_PERC;
      var MP= message.CURR_WITH_ORD_MAR;
      var NOF= message.CURR_NO_ORD_FUNDS;
      var NOR= message.CURR_NO_ORD_REVAL;
      var NOFE= message.CURR_NO_ORD_EXC_SHORT;
      var NOM= message.CURR_NO_ORD_MARG_AT_PERC;
      var NOMP= message.CURR_NO_ORD_MAR;
      var P=0;
      var L=0;
      var SP = new Map();
      var SF =new Map();
      var ORD =new Map();
      var FO=new Map();
      var UA=new Map();
      var TR=new Map();
      var DL=new Map();
      if(message.CURR_BAL!=undefined){
        const AccBal=JSON.parse(message.CURR_BAL);
        P=AccBal.MP;
        L=AccBal.LL;

        var totalFundsNoMarginOrd=AccBal.FA.TF;
        var buyOrdFunds=AccBal.FA.BO;
        var netFunds=AccBal.FA.NF;
        var noMrgOrdLossLimt=AccBal.FA.LL
        var noMrgRevaluation= message.CURR_NO_ORD_REVAL
        var noMrgNetFunds = AccBal.FA.TF
        var noMrgNetEquity = parseFloat(noMrgRevaluation) + parseFloat(noMrgNetFunds)

        AccBal.STKA.map((item,index) => {
          SP.set(item.C,item);
        });
        AccBal.STKA.map((item,index) => {
          ORD.set(item.C,item);
        });
        AccBal.STKA.map((item,index) => {
          FO.set(item.C,item);
        });
        AccBal.STKA.map((item,index) => {
          UA.set(item.C,item);
        });
        AccBal.STKA.map((item,index) => {
          TR.set(item.C,item);
        });
        AccBal.STKA.map((item,index) => {
          DL.set(item.C,item);
        });

        for (const currency of state.currencyData) {
          if(Array.isArray(AccBal.FA) === true){
            AccBal.FA.map((item) => {
              if (item.C === currency.S) {
                var Obj={};
                Obj.C=item.C;
                Obj.Q=item.FCQ;
                SF.set(item.C,Obj);
              }
            });
          }
        }
      }
    }

    return {
      defacccode:null,
      mrgPerc:MP,
      detonlBeanMap:SP,
      detFundsBeanMap:SF,
      detPhysicalBeanMap:DL,
      TQFlag:message.hasTransit===1?true:false,
      UQFlag:message.hasUnllocated===1?true:false,
      OQFlag:message.CO===1?true:false,
      FOQFlag:message.FO===1?true:false,
      totfunds:F,
      totReval:R,
      totmargin:M,
      margPerc:MP,
      excess:FE,
      noOrdtotfunds:NOF,
      noOrdtotReval:NOR,
      noOrdtotmargin:NOM,
      noOrdmargPerc:NOMP,
      noOrdexcess:NOFE,
      margPercLable:P,
      detOrderBeanMap:ORD,
      detFOBeanMap:FO,
      detTransitBeanMap:TR,
      detUnallocBeanMap:UA,
      lossLimit:L,
      totalFundsNoMarginOrd:totalFundsNoMarginOrd,
      buyOrdFunds:buyOrdFunds,
      netFunds:netFunds,
      noMrgOrdLossLimt:noMrgOrdLossLimt,
      noMrgRevaluation:noMrgRevaluation,
      noMrgNetEquity:noMrgNetEquity
    };
  }

const updateInst = (socketData, message) => {
	  const item = socketData.get(message.IID);
    item.OV=message.MIP;
    item.MXOV=message.MAPV;
    socketData.set(message.IID,item);
    return socketData;
}

const updateValDate =(socketData, message) => {
  for (var [_, item] of socketData) {
    var cmdty=item.I;
    for(let key of message.inst){
      if(key.IID === cmdty){
        item.VD=moment(key.VD).format(appConstants.valueDateFormat);
      }
    }
  }
  return socketData;
}

const setConvFactorData = (data) =>{
  try{
  var tmpConvFactor=[];
    const lengthTrdData = data.length;
    for (let index = 0; index < lengthTrdData; index++) {
    	var obj={};
    	obj.key=data[index].C;
    	obj.val=data[index].F;
        tmpConvFactor.push(obj);
    }
    localStorage.setItem('convFactor',JSON.stringify(tmpConvFactor));
  }catch(e){
	  console.log("e "+e)
  }
}

const getOpenTrades = (openTrade,opentradeBook ) => {
  try{
	  var openTradeArr=new Map();
	  var tempArr=JSON.parse(localStorage.getItem('convFactor'));
	  var convFactor = new Map(tempArr.map(i => [i.key, i.val]));
	  const user = JSON.parse(localStorage.getItem('user'));
	  var mult=1;
	  openTrade.map((order) => {
      // if(order.acc_code===JSON.parse(localStorage.getItem('DFA')).C){
      var dec = getDecimal(order.inst_id);
      const item1 = Object.assign([], JSON.parse(localStorage.getItem(order.inst_id)));
      let cmdtypair = item1.ID
	    if(convFactor.get(order.stk_code)!==undefined){
	    	mult=convFactor.get(order.stk_code);
	    }
	    var obj = {
	      'eventTime': moment(order.event_time).local().format(appConstants.actTimeDateTimeFormatter),
	      'deal': parseFloat(order.deal_type) === 1
	          ? "BUY"
	          : "SELL",
        'cmdtyPair':cmdtypair,
	      'iid':order.inst_id,
	      'quantity':Number(parseFloat(order.bal_pcs_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }),
	      'qtyType': order.stk_code,
	      'price': Number(parseFloat(order.rate)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
	      'gq':Number(parseFloat(order.bal_pur_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }),
	      'rate':order.rate,
	      'docNo': order.docno,
	      'unrealisedPL': order.PnL,
	      'Action': "",
        'selectedQty':0,
        'DocSrNo':order.docsrno
	    };
		    if(openTradeArr.get(order.inst_id)){
		    	openTradeArr.get(order.inst_id).push(obj);
		    }
		    else{
		    	localStorage.setItem('opTrade',1);
		    	var tempArr=[];
		    	tempArr.push(obj);
		    	openTradeArr.set(order.inst_id,tempArr);
		    }
      // }
	    });
	    opentradeBook.opentradesData = openTradeArr;
	    return opentradeBook;
  }catch(e){console.log("Error"+e);}
}

const openTrdBookSet = (opentradeBook,msgObj) =>{
 try{
 if(msgObj.BCM===appConstants.OPEN_TRADE){
   var openTradeArr = new Map();
   // if(msgObj.Type ==="Modify"){
     if(msgObj.AC===JSON.parse(localStorage.getItem('DFA')).C){
     var docArr=msgObj.DocData;
     for(var k=0;k<docArr.length;k++){
       var flag = 0;
       var tempArr = [];
       if(opentradeBook.opentradesData!==undefined && opentradeBook.opentradesData!==null && opentradeBook.opentradesData.length!=0){
			    if(opentradeBook.opentradesData.get(docArr[k].IID)){
         tempArr=opentradeBook.opentradesData.get(docArr[k].IID);
       }
     }
       for(var j=0;j<tempArr.length;j++){
         if(tempArr[j].docNo===docArr[k].DocNo){
           flag = 1;
           if(Number(parseFloat(docArr[k].bal_pcs_qty))===0){
             tempArr.splice(j,1);
           }else{
             tempArr[j].quantity=(Number(parseFloat(docArr[k].bal_pcs_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
             tempArr[j].gq=(Number(parseFloat(docArr[k].bal_pur_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
           }
           opentradeBook.opentradesData.set(docArr[k].IID,tempArr);
           break;
         }
       }
       // opentradeBook.opentradesData.set(docArr[k].IID,tempArr);
     // }
   // }else{
 //To add
 if (flag == 0 && Number(parseFloat(docArr[k].bal_pcs_qty))!==0) {
   var tempcArr=JSON.parse(localStorage.getItem('convFactor'));
    var convFactor = new Map(tempcArr.map(i => [i.key, i.val]));
    //var docArr=msgObj.DocData;
   //for(var k=0;k<docArr.length;k++){
   var dec = getDecimal(docArr[k].IID);
   const item1 = Object.assign([], JSON.parse(localStorage.getItem(docArr[k].IID)));
   let cmdtypair = item1.ID
   var obj = {
        'eventTime': moment(docArr[k].ET).local().format(appConstants.actTimeDateTimeFormatter),
        'deal': (parseInt(docArr[k].DT) === 1
            ? "BUY"
            : "SELL"),
        'cmdtyPair':cmdtypair,
        'iid':docArr[k].IID,
        'quantity':(Number(parseFloat(docArr[k].bal_pcs_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
        'qtyType': docArr[k].SC,
        'price': Number(parseFloat(docArr[k].R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }),
        'rate':docArr[k].R,
        'gq':(Number(parseFloat(docArr[k].bal_pur_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })),
        'docNo': docArr[k].DocNo,
        'unrealisedPL':0.00,
        'Action': "",
        'selectedQty':0,
        'DocSrNo':docArr[k].DocSrNo
      };
   var tempArr2=[];
   if(opentradeBook.opentradesData.length!==0)
   {
     if (opentradeBook.opentradesData.get(docArr[k].IID)) {
       tempArr2=opentradeBook.opentradesData.get(docArr[k].IID);
     }
     tempArr2.push(obj);
     opentradeBook.opentradesData.set(docArr[k].IID,tempArr2);
   }
   else {
     tempArr2.push(obj);
     openTradeArr.set(docArr[k].IID,tempArr2);
     opentradeBook.opentradesData = openTradeArr;
   }
   //}
 }
 }
}
 }
 return opentradeBook;
 }catch(e){console.log(e);}
 }

const getDecimal = (cmdtypair) => {
  var dec;
  var item =JSON.parse(localStorage.getItem(cmdtypair));
  //for (let index = 0; index < item.length; index++) {
    //  if (item[index].I === cmdtypair) {
        dec = item.dec
  //      break;
  //  }
//  }
  return dec;
}

const getStkCodeWiseMarkup = (stkWiseMarkup) =>{
  var stkWiseMarkupArr = new Map();
  for(let i=0;i<stkWiseMarkup.length;i++){
    stkWiseMarkupArr.set(stkWiseMarkup[i].IID,stkWiseMarkup[i].dataArr);
  }
  return stkWiseMarkupArr;
}

const updateStkCodeWiseMarkup = (stkWiseMarkup,msg) =>{
  let dataArr = stkWiseMarkup.get(msg.details.IID);
  for (var i = 0; i < dataArr.length; i++) {
    for (var j = 0; j < msg.details.dataArr.length; j++) {
      if (dataArr[i].SC === msg.details.dataArr[j].SC) {
        dataArr[i].SC = msg.details.dataArr[j].SC;
        dataArr[i].ASK = msg.details.dataArr[j].ASK;
        dataArr[i].BID = msg.details.dataArr[j].BID;
      }
    }
  }
  stkWiseMarkup.set(msg.details.IID,dataArr);
  return stkWiseMarkup;
}

const getAllRateData = (msg) =>{
  var socketAllRate = new Map();
  for(let i=0;i<msg.length;i++){
    var obj = {
      "cmdty": msg[i].I,
      "ask": msg[i].MA,
      "bid": msg[i].MB
    };
    socketAllRate.set(msg[i].I,obj);
  }
  return socketAllRate;
}
const getMetalCurrDropdown=(data)=>{
  let cmdtyArry=[];
  let cmdty_metal = [];
  for (let index = 0; index < data.length; index++) {
    if (data[index].I !== -1){
        let cmdtyDes;
        let cmdtyId;
        let obj={};
        if(data[index].TT1=="M") {
          cmdtyDes = data[index].D1;  /// getting XAU,XAG etc
          cmdtyId = data[index].T1;  /// getting GLD,PLD etc
          if(cmdtyArry.findIndex(x => (x.cmdtDesc== cmdtyDes)) === -1){
            obj = {cmdtDesc: cmdtyDes,cmdtId:data[index].T1}
            cmdtyArry.push(obj);
            if(data[index].B===2){
              cmdty_metal.push(data[index].D1);
           }
          }
        }

        if(data[index].TT2=="M"){
          cmdtyDes =data[index].D2;
          cmdtyId = data[index].T2;
          if(cmdtyArry.findIndex(x => (x.cmdtDesc== cmdtyDes)) === -1){
          obj = {cmdtDesc: cmdtyDes,cmdtId:data[index].T2}
          cmdtyArry.push(obj);
          }
        }
      }
  }
  cmdtyArry.cmdty_metal=cmdty_metal
  return cmdtyArry
}
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.SUCCESS_DEFAULT:
      return {
        ...state,
      };
    case types.FAILURE_DEFAULT:
      return {
        ...state,
      };
    case types.LOAD_INSTRUMENT_LIST:
      return {
        ...state,
      };
    case types.LOAD_INSTRUMENT_LIST_SUCCESS:
    	setConvFactorData(getInitialTradeData(action.result.dataObject.S));
      return {
        ...state,
        socketData: getInitialSocketData(action.result.dataObject.Inst),
        DCO:setDCO(action.result.dataObject.Inst),
        TCO:setTCO(action.result.dataObject.Inst),
        socketDataStatic: getInitialStaticSocketData(action.result.dataObject.Inst),
        trdPanelData: getInitialTradeData(action.result.dataObject.S),
        unitData: getInitialTradeData(action.result.dataObject.U),
        currencyData:getInitialTradeData(action.result.dataObject.C),
        localCurrency:getInitialTradeData(action.result.dataObject.BC),
        custInstStkData:getInitialTradeData(action.result.dataObject.CI),
        dropdown:getMetalCurrDropdown(action.result.dataObject.Inst)
        //socketAllRate:getInitialAllRateData(action.result.dataObject.Inst)
      };

    case types.LOAD_INSTRUMENT_LIST_FAILURE:
      return {
        ...state,
      };
    case types.LOAD_ALL_INSTRUMENTS:
        return {
          ...state,
        };
    case types.LOAD_ALL_INSTRUMENTS_SUCCESS:
      	//setConvFactorData(getInitialTradeData(action.result.dataObject.S));
        return {
          ...state,
          instData: getInstData(action.result.dataObject),
        };

    case types.LOAD_ALL_INSTRUMENTS_FAILURE:
        return {
          ...state,
        };
    case types.LOAD_MARGIN:
        return {
          ...state,
        };
    case types.LOAD_MARGIN_SUCCESS:
        return {
          ...state,
          accBalMargBean:getAccountBalMargin(state.socketData,action.result.dataObject),
        };

    case types.LOAD_MARGIN_FAILURE:
        return {
          ...state,
        };

    case types.NO_MARGIN_LOAD:
      return {
        ...state,
      };
    case types.NO_MARGIN_LOAD_SUCCESS:
      return {
        ...state,
        accBalMargBean:noMrgGetAccountBalMargin(state.socketData,action.result.dataObject),
      };

    case types.NO_MARGIN_LOAD_FAILURE:
      return {
        ...state,
      };

    case types.UPDATE_STATUS:
        localStorage.setItem('status', 1);
      	return {
          ...state,
          status: "1",
          apiFlag:true,
          wsStatus : 'reconnecting'
        };
    case types.UPDATE_SOCKET_DATA:
          const message=action.message;
          var refreshRandomNo=Math.floor((Math.random() * 100) + 1);
          localStorage.setItem('openTrdRandomNoDB', refreshRandomNo);
          try{
          const msgData=JSON.parse(message.data);
          const BCM=msgData.BCM;
          if(BCM!==undefined){
            if(BCM===appConstants.CONN_STATUS_CHANGE){
              localStorage.setItem('status', JSON.parse(message.data).S);
              return{
                ...state,
                status:JSON.parse(message.data).S,
                apiFlag:false,
                wsStatus : state.wsStatus === 'reconnecting' ? 'reconnect' : null
              };
            }else if(BCM==="901"){
              if(JSON.parse(message.data).data.mrgn.CURR_BAL !== null){
                return {
                  ...state,
                  check:""+Math.random(),
                  socketData: getUpdatedSocketData(state.socketData, action.message),
                  socketAllRate: state.loadAllRate === true ? getAllRateData(msgData.data.allRate) : state.socketAllRate,
                  accBalMargBean:getUpdateAccBalMrg(state, JSON.parse(message.data).data.mrgn),
                };
             }else {
               return {
                 ...state,
                 check:""+Math.random(),
                 socketData: getUpdatedSocketData(state.socketData, action.message),
                 socketAllRate: state.loadAllRate === true ? getAllRateData(msgData.data.allRate) : state.socketAllRate
               };
             }
            }
          }
        }catch(e){console.log(e)};
    // }
    //need to check when this come
    case types.UPDATEMARGIN:
    return{
      ...state,
    //  accBalBean:updateMargin(state.accBalBean,state)
    };
    case types.LOAD_SOCKET_DATA:
      return {
        ...state,
        wsStatus : 'connected'
      };
    case types.CLOSE_SOCKET_DATA:
      return {
        ...state,
        webSocketFlag:false,
        wsStatus : 'disconnected'
      };
      case types.SUBSCRIBE_TIER:
      return {
        ...state,
      }
      case types.UNSUBSCRIBE_TIER:
      return {
        ...state,
      }
      case types.UPDATE_ACCBAL:
        return {
          ...state,
          //accBalBean:updateAccbalBean(action.msg,state.accBalBean,state.socketData,state.socketNeoData),
        }
        case types.UPDATE_INST:
        return{
          ...state,
          socketData:updateInst(state.socketData,action.msg)
        }
        case types.UPDATE_MARGIN_PERC:
        return{
          ...state,
          accBalBean:updateAccbalBeanMrgPerc(action.msg,state.accBalMargBean,state.socketData,state.socketNeoData),
        }

        case types.SOCKET_FLAG:
        var flag=action.flag;
        return{
          ...state,
          webSocketFlag:flag,
        }
        case types.UPDATE_VALUEDATE:
        return{
          ...state,
          socketData:updateValDate(state.socketData,action.message),
          check:""+Math.random()
        }
        case types.RESET_STATE_SOCKET:
      		return{
      			...state,
            socketData: [],
            socketDataStatic: [],
            socketNeoData:[],
            trdPanelData:[],
            custInstStkData:[]
      		}
       case authTypes.SAVE_SETTING_SUCCESS:
        	return{
        		...state,
        		AccChange:true
        	}
          case acttypes.GET_OPENTRADES_DATA:
            return {
              ...state
              };
          case acttypes.OPENTRD_REFRESH_FLAG:
          return{
            ...state,
            openTradeLoaderFlag:action.flag
          };
        case acttypes.GET_OPENTRADES_DATA_SUCCESS:
      	    var refreshRandomNo=Math.floor((Math.random() * 100) + 1);
            localStorage.setItem('openTrdRandomNoDB', refreshRandomNo);
            return {
                ...state,
                openTrdRandomNoDB:refreshRandomNo,
                opentradeBook: getOpenTrades(action.result.dataObject.openTrade, state.opentradeBook),
                openTradeLoaderFlag:false
              };
        case acttypes.GET_OPENTRADES_DATA_FAILURE:

          return {
            ...state
           };
       case acttypes.GET_ALL_ORDER_DATA_SUCCESS:
           var refreshRandomNo=Math.floor((Math.random() * 100) + 1);
           localStorage.setItem('randomNoDB', refreshRandomNo);
           var requestRejectModal=[{mdflag:false,title:"",msg:"",CTID:""}];
           localStorage.setItem('requestRejectModal',JSON.stringify(requestRejectModal));
           var opentradeArray=action.result.dataObject.length===4?action.result.dataObject[3].openTrade:[];
           return {
               ...state,
               randomNoDB:refreshRandomNo,
               openTrdRandomNoDB:refreshRandomNo,
               opentradeBook: getOpenTrades(opentradeArray, state.opentradeBook),
               LoadFlag:false,
               openTradeLoaderFlag:false
             };
       case types.OPEN_TRADE:
          var refreshRandomNo=Math.floor((Math.random() * 100) + 1);
    	   return{
             ...state,
             openTrdRandomNoDB:refreshRandomNo,
    	   		opentradeBook: openTrdBookSet(state.opentradeBook,action.msg),
       		}
        case types.LOAD_MARKUP:
          return {
            ...state,
          };
        case types.LOAD_MARKUP_SUCCESS:
        var randonNo=Math.floor((Math.random() * 100) + 1);
          return {
            ...state,
            stkWiseMarkup:getStkCodeWiseMarkup(action.result.dataObject),
            stkWiseMarkupRandomNo:randonNo
          };

      case types.LOAD_MARKUP_FAILURE:
          return {
            ...state,
          };
      case types.UPDATE_STK_MARKUP:
      var randonNo=Math.floor((Math.random() * 100) + 1);
          return {
            ...state,
          stkWiseMarkup:updateStkCodeWiseMarkup(state.stkWiseMarkup,action.message),
          stkWiseMarkupRandomNo:randonNo
          };
      case types.LOAD_ALL_RATE_DATA:
        var flag=action.flag;
        return{
          ...state,
          loadAllRate:flag
        }
    default:
      return state;
  }
}
